import {
  CreateFieldInput,
  CreateFieldSelect,
  CreateFieldTextarea,
  CreateFormActions,
  CreateNextSteps,
  PageTitle
} from '../../components.js';
import { Page } from '../base.js';

export class BrandsCreate extends Page {
  static statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'archived', label: 'Archived' }
  ];

  static nextSteps = [
    { icon: 'globe', label: 'Connect a custom domain' },
    { icon: 'settings', label: 'Customize brand styling' },
    { icon: 'mail', label: 'Set support contact details' },
    { icon: 'form', label: 'Apply the brand to content' }
  ];

  static timlComponents = {
    CreateFieldInput,
    CreateFieldSelect,
    CreateFieldTextarea,
    CreateFormActions,
    CreateNextSteps,
    PageTitle
  };

  static get formAction() {
    return API.resourceUrl('brands');
  }

  static timl = `
    .auth-create-page.brands-create-page
      <PageTitle title="Create Brand">
      .auth-create-content
        p.auth-create-description Create a brand for your domains, content, and customer communications.
        .create-page-grid
          form.create-form-card[method="POST" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/brands"]
            .create-form-body
              <CreateFieldInput label="Name" name="name" placeholder="e.g. Acme" hint="The customer-facing name for this brand.">
              <CreateFieldInput label="Slug (optional)" name="slug" placeholder="e.g. acme" required="false">
              <CreateFieldInput label="Domain (optional)" name="domain" placeholder="e.g. app.acme.com" required="false">
              <CreateFieldTextarea label="Description (optional)" name="description" placeholder="Describe this brand" required="false" rows="4">
              <CreateFieldInput label="Logo URL (optional)" name="logoUrl" placeholder="https://..." required="false">
              <CreateFieldInput label="Primary color (optional)" name="primaryColor" placeholder="#000000" required="false">
              <CreateFieldInput label="Support email (optional)" name="supportEmail" type="email" placeholder="support@example.com" required="false">
              <CreateFieldSelect label="Status" name="status" options="{{ Routing.routeObject.statusOptions }}" value="active">
            <CreateFormActions submitLabel="Create" cancelHref="/brands">
          <CreateNextSteps items="{{ Routing.routeObject.nextSteps }}">
  `;
}
